import type { IconProps } from '../create-icon'

// Official VALORANT Controller role glyph (traced from Riot's role displayIcon).
// Filled disc with the symbol punched out as negative space — matches in-game art.
export function ValController({
  size = 24,
  color = 'currentColor',
  className,
  style,
  ...rest
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 128 128"
      fill={color}
      className={className}
      style={style}
      {...rest}
    >
      <g transform="translate(0,128) scale(0.1,-0.1)">
        <path d="M500 1264 c-234 -50 -436 -254 -485 -489 -16 -77 -20 -149 -7 -143 5 2 147 118 316 258 169 140 313 255 321 255 8 0 154 -116 325 -257 l310 -258 0 38 c0 70 -30 177 -71 262 -127 256 -423 396 -709 334z M370 629 c-146 -122 -276 -230 -288 -240 l-24 -18 27 -49 c15 -28 46 -70 68 -96 l42 -45 215 180 c118 99 221 182 227 185 11 5 138 -95 407 -320 l48 -41 39 45 c45 52 93 136 85 149 -10 16 -557 466 -569 468 -7 1 -131 -97 -277 -218z M518 152 c-64 -53 -117 -100 -117 -103 -2 -13 128 -42 209 -46 83 -5 186 10 253 36 l29 11 -120 100 c-66 55 -124 100 -128 100 -5 -1 -62 -45 -126 -98z" />
      </g>
    </svg>
  )
}
